import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const AudioContext = createContext();

// Create a provider component
export const AudioProvider = ({ children }) => {
    const [currentChannel, setCurrentChannel] = useState(() => {
        const savedChannel = localStorage.getItem('currentChannel');
        return savedChannel
            ? JSON.parse(savedChannel)
            : {
                  name: 'Channel Name',
                  url_resolved: 'https://stream-155.zeno.fm/70nen96vgs8uv',
              };
    });

    const [isPlaying, setIsPlaying] = useState(() => {
        const savedPlaying = localStorage.getItem('isPlaying');
        return savedPlaying === 'true'; // Convert to boolean
    });

    // Persist current channel and playing state in localStorage
    useEffect(() => {
        localStorage.setItem('currentChannel', JSON.stringify(currentChannel));
    }, [currentChannel]);

    useEffect(() => {
        localStorage.setItem('isPlaying', isPlaying);
    }, [isPlaying]);

    // Ensure playback continues after a reload
    useEffect(() => {
        if (isPlaying) {
            setTimeout(() => {
                setIsPlaying(true);
            }, 100);
        }
    }, []); // Run once when the app starts

    return (
        <AudioContext.Provider
            value={{
                currentChannel,
                setCurrentChannel,
                isPlaying,
                setIsPlaying,
            }}
        >
            {children}
        </AudioContext.Provider>
    );
};
